<template>
    <div class="cover-video">
        <img class="cycle" v-lazy="'/img/supersta-t.png'" alt="">
        <img class="mask" v-lazy="'/img/mask.png'" alt="">
        <img class="pico" v-lazy="'/img/pico-t.png'" alt="">
        <img class="owl" v-lazy="'/img/ulo-t.png'" alt="">
        <img class="vaze" v-lazy="'/img/Terraplanter-t3.png'" alt="">
        <img class="hd" v-lazy="'/img/2.png'" alt="">
        <img class="ciga" v-lazy="'/img/sig.png'" alt="">
        <img class="rob" v-lazy="'/img/rob.png'" alt="">
        <img class="small" v-lazy="'/img/Fidget-t.png'" alt="">
        <img class="w" v-lazy="'/img/w.png'" alt="">
        <button @click="playVideo">
            <PlayIcon/>
        </button>
        <HomepageVideo/>
    </div>
</template>

<script>
import {PlayIcon} from '../Icons'
import HomepageVideo from '../../popups/HomepageVideo'
export default {
    name: 'HeadingVideo',
    components: {
        PlayIcon,
        HomepageVideo
    },
    methods: {
        playVideo(){
            this.$bvModal.show('homepage-video')
        }
    }
}
</script>

<style lang="scss" scoped> 
div.cover-video {
    width: 510px;
    height: 337px;
    position: relative;
    button {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        margin: auto;
        z-index: 4;        
    }
    img {   
        position: absolute;
        z-index: 2;
        transition: all 0.3s ease ;
        &.cycle {
            top: 0;
            left: 0;
            z-index: 1;
        }
        &.mask {
            top: 69px;
            left: 90px;
        }
        &.owl {
            top: 97px;
            right: 158px;
        }
        &.pico {
            top: 55px;
            right: 31px;
        }
        &.vaze {
            bottom: 31px;
            left: 124px;
        }
        &.hd {
            bottom: 0;
            left: 38px;
        }
        &.ciga {
            bottom: 9px;
            left: 129px;
        }
        &.rob {
            bottom: 0;
            right: 158px;
        }
        &.small {
            bottom: 24px;
            right: 103px;
        }
        &.w {
            bottom: 13px;
            right: 0;
        }
    }
}
</style>